import { Button } from "@/components/ui/button";
import { SeletorQuantidadeCompraRapida } from "@/components/SeletorQuantidadeCompraRapida";
import { EtapasCompraRapida } from ".."
import { labelPlural } from "@/utils/copyTituloBilhete";

interface EtapaSelecionarQuantidadeProps {
    alterarEtapa: (etapa: EtapasCompraRapida) => void,
    alterarQuantidade: (quantidade: number) => void,
    quantidade: number
}

export function EtapaSelecionarQuantidade({ quantidade, alterarQuantidade, alterarEtapa }: EtapaSelecionarQuantidadeProps) {

    return (
        <div className="flex flex-col">
            <h1 className="text-center text-primary font-semibold text-xl">
                Quantidade de {labelPlural()}
            </h1>
            <div className="mb-5 mt-2">
                <SeletorQuantidadeCompraRapida
                    quantidade={quantidade}
                    onChange={alterarQuantidade}
                    size="sm"
                />
            </div>
            <div className="flex justify-center">
                <Button
                    disabled={quantidade === 0}
                    type="button"
                    onClick={() => alterarEtapa(EtapasCompraRapida.InserirCPF)}
                    variant="foreground"
                    className="mt-2">
                    Continuar
                </Button>
            </div>
        </div>
    )
}